export default "__VITE_IMAGE_ASSET__bdc37d6d__";